import api from './api';

export interface BricksLevel {
  id: number;
  numero_nivel: number;
  dificultad_id: number;
  size: number;
  author: string;
  areas: string;
  problem: string[];
  solution: string[];
}

export interface BricksProgress {
  completado: boolean;
  mejor_tiempo?: number;
  menos_movimientos?: number;
  fecha_completado?: string;
}

export interface BricksLevelResponse {
  level: BricksLevel;
  progress: BricksProgress | null;
}

/**
 * Obtener niveles disponibles
 */
export async function getBricksLevels(dificultad: number): Promise<number[]> {
  const response = await api.get(`/bricks/levels?dificultad=${dificultad}`);
  return response.data.levels;
}

/**
 * Obtener un nivel específico
 */
export async function getBricksLevel(
  dificultad: number,
  numeroNivel?: number,
  userId?: number
): Promise<BricksLevelResponse> {
  let url = `/bricks/level?dificultad=${dificultad}`;
  if (numeroNivel) url += `&numero=${numeroNivel}`;
  if (userId) url += `&userId=${userId}`;

  const response = await api.get(url);
  return response.data;
}

/**
 * Generar puzzle aleatorio con el generador
 */
export async function generateBricksPuzzle(dificultad: number, seed?: number): Promise<BricksLevel> {
  let url = `/bricks/generate?dificultad=${dificultad}`;
  if (seed !== undefined) url += `&seed=${seed}`;
  const response = await api.get(url);
  const data = response.data;
  return {
    id: data.seed,
    numero_nivel: 0,
    dificultad_id: dificultad,
    size: data.size,
    author: 'generator',
    areas: data.areas,
    problem: data.problem.map((row: string) => row),
    solution: data.solution.map((row: string) => row),
  };
}

/**
 * Validar solución
 */
export async function validateBricksSolution(
  userBoard: string[][],
  solution: string[][],
  areas: string
): Promise<{ valid: boolean; errors: string[] }> {
  const response = await api.post('/bricks/validate', {
    userBoard,
    solution,
    areas
  });
  return response.data;
}
